/* PMSTEEL · Quick pick — anchored dropdown popover replacing Dawn's bulk
   "Choose options" modal on product cards. One delegated listener handles
   every card on the page (the same script tag renders per-card; the guard
   ensures it only wires up once). Adding a variant uses the Cart + Section
   Rendering API so Dawn's cart drawer/notification refreshes in place, and
   publishes cartUpdate so the header mini-cart stays in sync. */
(function () {
  if (window.__pmsteelQuickPick) return;
  window.__pmsteelQuickPick = true;

  function raise(qp, on) {
    var host = qp.closest('.grid__item') || qp.closest('.card-wrapper') || qp.closest('.card');
    if (host) host.classList.toggle('pmsteel-qp-raised', on);
  }

  function setFeedback(qp, type, message) {
    var status = qp.querySelector('[data-qp-status]');
    var error = qp.querySelector('[data-qp-error]');
    if (status) status.textContent = type === 'status' ? message : '';
    if (error) error.textContent = type === 'error' ? message : '';
  }

  function getErrorMessage(qp, data) {
    if (data && typeof data.description === 'string' && data.description.trim()) return data.description;
    if (data && typeof data.message === 'string' && data.message.trim()) return data.message;
    return qp.getAttribute('data-qp-error-message') || '';
  }

  function closeAll(except, focusOwner) {
    document.querySelectorAll('[data-pmsteel-qp].is-open').forEach(function (qp) {
      if (qp === except) return;
      var panel = qp.querySelector('.pmsteel-qp__panel');
      var toggle = qp.querySelector('[data-qp-toggle]');
      if (toggle && (qp === focusOwner || qp.contains(document.activeElement))) toggle.focus();
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      qp.classList.remove('is-open');
      raise(qp, false);
    });
  }

  function addVariant(btn) {
    var qp = btn.closest('[data-pmsteel-qp]');
    if (!qp) return;
    var id = btn.getAttribute('data-qp-add');
    var failed = false;
    setFeedback(qp, '', '');
    btn.disabled = true;
    btn.classList.add('is-busy');

    var host = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = new FormData();
    body.append('id', id);
    body.append('quantity', 1);
    if (host && typeof host.getSectionsToRender === 'function') {
      body.append('sections', host.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', window.location.pathname);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data;
        if (!result.ok || data.status) {
          failed = true;
          setFeedback(qp, 'error', getErrorMessage(qp, data));
          return;
        }
        if (host && typeof host.renderContents === 'function') host.renderContents(data);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pmsteel-quick-pick', cartData: data });
        }
        setFeedback(qp, 'status', qp.getAttribute('data-qp-success-message') || '');
        closeAll(null, qp);
      })
      .catch(function () {
        failed = true;
        setFeedback(qp, 'error', getErrorMessage(qp));
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-busy');
        if (failed) btn.focus();
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-qp-toggle]');
    if (toggle) {
      if (toggle.disabled) return;
      var qp = toggle.closest('[data-pmsteel-qp]');
      closeAll(qp);
      var open = qp.classList.toggle('is-open');
      raise(qp, open);
      var panel = qp.querySelector('.pmsteel-qp__panel');
      if (panel) panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) setFeedback(qp, '', '');
      return;
    }
    var addBtn = e.target.closest('[data-qp-add]');
    if (addBtn) { addVariant(addBtn); return; }
    if (!e.target.closest('[data-pmsteel-qp]')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();
